export const profiles = [
    {
        id: "about-me",
        type: "text",
        title: "About Me",
        description: `Hi! My name is Cynthia, and I'm a PhD student at the Paul G. Allen School at the University of Washington, advised by Kurtis Heimerl and Shwetak Patel.\n
        I attended UNC Chapel Hill and graduated in 2021 (B.S./B.A. Computer Science/Peace, War, and Defense; chemistry minor).\n
        At UNC, I worked in the Neural Engineering Lab on a number of projects, ranging from behavioral studies of mice to optimizing pipelines for closed-loop neural processing.\n
        I then spent two interesting years at C3.AI working on projects ranging from engine fuel efficiency to optimizing drug manufacturing.\n
        Directly prior to starting my PhD, I worked in Cecilia Mascolo's lab on quantized test-time adaptation, at the Computer Lab at the University of Cambridge as part of my MPhil in Computer Science.\n
        My current research seeks to understand how existing AI systems may or may not be suitable for out-of-distribution contexts, particularly in global health.\n
        Outside of research, I am a big fan of running, reading, rowing, riting, retc.
        `
    },
    {
        id: "words",
        type: "list",
        title: "Writing",
        description: `Before I wrote code...I wrote words. Here are some of my articles:`,
        links: [
            { 
                url: "https://www.dailytarheel.com/article/2021/03/dth-meta-analysis",
                title: "Looking back at the DTH's coverage of this historic year, over 2,700 stories later",
                dataViz: true
            },
            {
                url: "https://www.dailytarheel.com/article/2021/01/university-campus-y-break-in",
                title: "'Public display of division': Campus Y vandalized with anti-Semitic, racist symbols",
                dataViz: false
            },
            {
                url: "https://www.dailytarheel.com/article/2020/10/university-international-student-experience",
                title:"Midnight classes, thousands of miles away: Living abroad during UNC's remote semester",
                dataViz: false
            },
            {
                url: "https://www.dailytarheel.com/article/2020/10/city-food-insecurity",
                title: "COVID-19 increases food insecurity for low-income residents",
                dataViz: true
            },
            {
                url:"https://www.dailytarheel.com/article/2020/08/carolina-ready-app-0811",
                title: "Carolina Ready app brings new safety features — and new student concerns",
                dataViz: false
            },
            {
                url:"https://www.dailytarheel.com/article/2020/08/avatar-tv-show-column-0811",
                title: "Analysis: 'Avatar: The Last Airbender' is a show for our moment",
                dataViz: false
            },
            {
                url:"https://www.dailytarheel.com/article/2020/06/no-contact-orders",
                title:"'It’s not on us': From UNC to the courts, restraining order enforcement raises concerns",
                dataViz: false
            },
            {
                url:"https://www.dailytarheel.com/article/2019/09/us-china-students",
                title:"How students get caught up in the U.S.-China trade war",
                dataViz: false
            },
            {
                url:"https://www.dailytarheel.com/search?a=1&s=&ti=&ts_month=0&ts_day=0&ts_year=0&te_month=0&te_day=0&te_year=0&au=Cynthia+Dong&tg=&ty=0",
                title:"See more here.",
                dataViz: false
            }
        ] 
    },
    {
        id: "graphics",
        type: "img-list",
        title: "Graphics",
        description: "Some graphics I made in Adobe Illustrator for various hackathons:"
    },
    {
        id: "misc",
        type: "list",
        title: "Miscellaneous",
        description: `Various things that I find interesting:`,
        links: [
            {
                url: "https://solar.lowtechmagazine.com/about.html",
                title: "Low Tech Magazine...powered by the sun!"
            },
            {
                url: "https://en.wikipedia.org/wiki/N%C3%BCshu",
                title: "A women-only written variant of Mandarin."
            },
            {
                url: "https://businessnc.com/butler-farms-has-the-ingredients-to-generate-energy/",
                title: "Hog waste-fueled microgrid in NC."
            },
            {
                url: "https://healthtalk.unchealthcare.org/sock-monkeys-and-fiberglass-cows/",
                title: "A tribute to the fearless leader of the sock monkey ladies."
            },
            {
                url: "https://colab.research.google.com/drive/1yKoyi1Fz9bzNtOhrjuC8h12_WzWHYIvz?usp=sharing",
                title: "Try the (preliminary) demo for the project I worked on for the Neural Engineering Lab at UNC."
            }
        ]
    }
]

export const tabs = [
    "about me",
    "words",
    "graphics",
    "miscellaneous",
]